const Generic = require("../GenericThemeFunctions")

module.exports = {
    defaultLanguage: 'es',
    scssVariables: './src/styles/tcl2024-tcl',
    randomNickname:  () => { return Generic.RandomNickname() },
    defaultPassword: 'default'
}